import { render } from "./ArchiveIcon.vue?vue&type=template&id=1784c0e8"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/ArchiveIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1784c0e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1784c0e8', __exports__)) {
    api.reload('1784c0e8', __exports__)
  }
  
  module.hot.accept("./ArchiveIcon.vue?vue&type=template&id=1784c0e8", () => {
    api.rerender('1784c0e8', render)
  })

}


export default __exports__